<template>
  <div class="question">
    <div class="edit-question-group w-11/12 flex flex-wrap justify-end" v-if="active">
      <label class="w-full" for="">Question</label>
      <markdown-editor class="w-full question-field" ref="markdownEditor" v-model="question.content_md" :options="{hideModeSwitch:true,previewStyle:'tab'}" height="200px" />
      <div class="flex w-full justify-between mt-3">
        <div class="flex w-1/3">
          <vs-switch label="shufle" v-model="question.shuffle_answers" :checked="question.shuffle_answers" class="mr-3 shuffle-answers" />
          <label>Shuffle answers</label>
        </div>
        <div>
          <vs-button class="mt-3 mr-5 save-button" color="primary" type="filled" icon-pack="feather" @click.stop="finishAndClose">Save</vs-button>
          <vs-button class="mt-3 cancel-button" color="primary" type="border" icon-pack="feather" @click.stop="closeEdition">Cancel</vs-button>
        </div>
      </div>
    </div>
    <div class="view-question-group" ref="questioncontent" v-else>
      <div class="view-question flex justify-end">
        <div 
          class="w-full cursor-pointer p-4 border border-solid rounded border-grey-light question-content"
          @click.stop="active = true"
        >
          <prism-markdown :content="question.content_md || 'empty question'" />
        </div>
        <div class="p-4 cursor-pointer delete-question" @click.stop="deleteQuestion(index)" title="Delete question">
          <feather-icon icon="Trash2Icon" svgClasses="h-5 w-5 color-current text-danger"/>
        </div>
      </div>
    </div>


    <div class="ml-10 answers-list" v-if="question.answers && question.answers.length">
      <div class="mt-8 answer" v-for="aIndex in question.answers" :key="aIndex">
        <answer-content
          :answer="answers[aIndex]"
          :index="aIndex"
          @finish-edit-answer="$emit('finish-edit-answer', {...$event, questionId: question.id || index})"
          @delete-answer="$emit('delete-answer', {...$event, questionId: question.id || index})"
        />
      </div>
    </div>

    <div class="add-answer-btn flex text-lg ml-10 mt-8 cursor-pointer" @click.stop="addAnswer(index)"><feather-icon icon="PlusCircleIcon" svgClasses="h-6 w-6" class="mr-4" />
      Add answer
    </div>
  </div>
</template>
<script>
import MarkdownEditor from '@/components/markdownEditor'
import PrismMarkdown from '@/components/PrismMarkup'
import AnswerContent from './AnswerContent'

export default {
  components: {
    MarkdownEditor,
    PrismMarkdown,
    AnswerContent
  },
  props: {
    question: Object,
    index: [String, Number],
    answers: Object,
    finishEditQuestion: Function,
    deleteQuestion: Function,
    addAnswer: Function
  },
  data: () => {
    return {
      active: false
    }
  },
  methods: {
    async finishAndClose() {
      const response = await this.finishEditQuestion(this.question, this.index)
      if (response) this.active = false
    },
    closeEdition () {
      this.active = false
    },
    updatePrism() {
      this.$nextTick().then(() => {
        if (this.$refs.questioncontent) {
          if (window.MathJax) {
            window.MathJax.Hub.Config({
              tex2jax: {
                inlineMath: [['$', '$']],
                displayMath: [['$$', '$$']],
                processEscapes: true,
                processEnvironments: true,
              },
              // Center justify equations in code and markdown cells. Elsewhere
              // we use CSS to left justify single line equations in code cells.
              displayAlign: 'center',
              'HTML-CSS': {
                styles: { '.MathJax_Display': { margin: 0 } },
                linebreaks: { automatic: true },
              },
            })
            window.MathJax.Hub.Queue([
              'Typeset',
              window.MathJax.Hub,
              this.$refs.questioncontent,
            ])
          }
        }
      })
    },
  },
  mounted() {
    this.active = !this.question.id
  },
  watch: {
    active(newValue) {
      if (!newValue)
        this.updatePrism()
    }
  }
}
</script>
<style lang="scss">
.question-content {
  transition: background-color .2s ease;
  &:hover {
    background: #f5f5f5
  }
  img {
    max-width: 100%;
    height: auto;
    display: block;
  }
}
</style>